import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row } from 'react-bootstrap';

const DPSinfo = () => {
    const faqs = [
        {
            title: <>Que veut dire DPS ?</>,
            description: <>
                Un DPS est un Dispositif Prévisionnel de Secours. Il s'agit de l'ensemble des moyens de secours à personne mis en place afin de parer à toute éventualité sur un évènement.
            </>
        },
        {
            title: <>Qui peut fournir une prestation de DPS ?</>,
            description: <>
                En France, seules les AASC (Associations Agréées de Sécurité Civile) peuvent tenir un DPS. L'UNASS fait partie de ces associations et peut donc vous proposer ce service.
            </>
        },
        {
            title: <>Que veulent dire <i>dispositif acteur</i> et <i>dispositif spectateur</i> ?</>,
            description: <>
                Votre évènement/manifestation peut comprendre deux typologies de personnes. Les acteurs sont ceux qui réalisent l'activité (les coureurs de votre course, l'artificer qui tire votre feu d'artifice, les danseurs qui sont sur scène, ...). Les spectateurs sont ceux qui ne réalisent pas l'activité.<br/>
                Lorsqu'un DPS est dimensionné, les deux aspects <i>acteurs</i> et <i>spectateurs</i> sont analysés séparemments. Votre évènement peut avoir besoin de couvrir l'un ou l'autre, ou les deux.<br/>
                Lorsque vous remplissez un formulaire de demande de DPS, il vous est demandé de décrire les deux aspects (présence d'acteurs ou pas, présence de spectateurs ou pas). Nous saurons ensuite vous guider dans la mise en place d'un DPS répondant à la règlementation en vigueur et à tous vos besoins.
            </>
        },
        {
            title: <>Comment est dimensionné un DPS ?</>,
            description: <>
                <u>De manière générale:</u> le nombre d'intervenants secouristes (hors logisticiens et chaine de commandement) est toujours un nombre pair.<br/>
                <u>Le dispositif <i>spectateur</i>:</u> cette partie du dispositif est régie par un référentiel national. Un calcul mathématique est réalisé sur la base d'indicateurs fournis dans la demande de DPS. Il en sort un volume minimal de secouristes présents. Nous pourrons par contre majorer ce volume sur la base de notre expérience et afin de répondre convenablement à votre besoin.<br/>
                <u>Le dispositif <i>acteur</i>:</u> il n'y a pas de calcul aboutissant à un dimmensionnement de DPS. Néanmoins, un dispositif acteur ne peut être dimensionné à moins de 4 intervenants secouristes. Suite à votre demande de DPS, nous vous ferrons une proposition de dimmensionnement qui pourra être retravaillée par la suite.
            </>
        },
        {
            title: <>Comment se déroule une demande de DPS ?</>,
            description: <>
                <ol>
                    <li><Link to="/demandeDPS">Vous effectuez une demande de DPS.</Link></li>
                    <li>Nous étudions votre demande et revenons vers vous quant à notre disponibilité pour effectuer la prestation.</li>
                    <li>Nous vous faisons une proposition de DPS, détaillant les moyens, l'implémentation, tous les détails opérationnels. Ainsi qu'un devis.</li>
                    <li>Une fois le devis accepté, nous bloquons le créneau dans notre planning, et commençons à travailler sur la convention (contrat qui nous liera).</li>
                    <li>Nous vous soumettons pour signature la convention, document exhaustif qui détaille l'intégralité de la prestation. Il s'agit du contrat nous liant sur cette prestation.</li>
                    <li>Une fois la convention signée, il ne reste plus qu'à préparer les détails techniques/logistiques, et à être à vos côtés le jour J !</li>
                </ol>
            </>
        },
        {
            title: <>De quels autres services ai-je besoin ?</>,
            description: <>
                Fort probablement: rien de plus que le DPS secouristes.<br/>
                Toutefois, certaines fédérations sportives peuvent imposer la présence d'autres moyens comme des ambulances privées par exemple. Les services de préfecture peuvent également imposer un dimmensionnement spécifique du DPS avec la présence d'autres moyens (pompiers, SAMU, ...). Votre site peut également être doté d'un PSI (Plan de Sécurité Intérieur) qu'il est obligatoire de respecter.
            </>
        },
        {
            title: <>Qu'est-ce qu'une SME ?</>,
            description: <>
                Une SME est une Société de Médicalisation. Elle fournit une prestation <u>complémentaire</u> au DPS tenu par les secouristes. La présence d'une SME n'est pas obligatoire (hormis mention contraire dans des textes de fédérations spécifiques, ou consignes préfectorales).<br/>
                Le rayon d'action d'une SME sur un DPS se limite à la médicalisation des interventions de secours. Il est légalement interdit à une SME d'assurer seule le DPS (donc sans secouristes), ou d'en prendre la responsabilité, coordination, ou direction. Seul le Responsable Associatif Secouriste dirige le DPS.<br/>
                Références légales: Article 121-2 du Code Pénal, Article L.752-2 du Code Pénal, Article 725-3 du Code de la sécurité intérieure
            </>
        },
        {
            title: <>Le jour J, comment ça se passe ?</>,
            description: <>
                Nos équipes arrivent à l'heure demandée (avec en général un peu d'avance). Nous montons le dispositif de secours comme convenu, vous n'avez pas à vous occuper de nous. Si votre évènement fait l'objet de consignes particulières, nous participons au briefing avec vos équipes afin de travailler main dans la main. Le Chef de Dispositif est votre seul contact, c'est à lui de coordonner ses équipes en aval.<br/>
                Si votre évènement comprend un Poste de Commandement, notre Chef de Dispositif y restera durant toute la durée de l'évènement afin d'être au plus proche de vous et de votre coordination.<br/>
                Si un incident venait à se produire, nos équipes interviendrons dès connaissance de l'incident/victimes. Si une évacuation sur centre hospitalier est nécessaire, c'est notre Chef de Dispositif qui se charge de la régulation SAMU et de la logistique qui gravite autour de cette évacuation.<br/>
                Pour les gros évènements, vous pouvez nous demande un statut régulier des postes de secours, voir même un accès en consultation sur notre système de traçabilité de l'activité de secours.
            </>
        },
        {
            title: <>Mon besoin est complexe et j'ai besoin d'aide</>,
            description: <>
                Et oui, certains évènements sont importants, rassemblent beaucoup de monde, s'étalent sur des centaines de kilomètres, ... pas de panique nous sommes là pour vous aider.<br/>
                Au-delàs de la simple tenue du DPS, travailler avec l'UNASS c'est bénéficier d'une prestation complète comprenant un accompagnement sur les sujets cartographiques, une présence en réunion préfectorales, des moyens de communication pour votre évènement, des solutions informatiques de main courante et traçabilité. Bref nous avons autant de levier que vous auriez de problématiques. Nous sommes à vos côtés sur toutes les étapes de votre évènement.
            </>
        },
        {
            title: <></>,
            description: <>
            </>
        },
    ];

    return (<>
        <Card>
            <Card.Header>
                <h5 className="mb-0">Qu'est-ce qu'un DPS ?</h5>
            </Card.Header>
            <Card.Body className="bg-body-tertiary pb-0">
                <Row>
                    <Col lg={6}>
                        {faqs.slice(0, Math.floor(faqs.length / 2)).map(faq => (<>
                            <h5 className="fs-9">{faq.title}</h5>
                            <p className="fs-10">{faq.description}</p>
                        </>))}
                    </Col>
                    <Col lg={6}>
                        {faqs.slice(Math.floor(faqs.length / 2)).map(faq => (<>
                            <h5 className="fs-9">{faq.title}</h5>
                            <p className="fs-10">{faq.description}</p>
                        </>))}
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer className="py-3">
                <div className="text-center">
                    <Row>
                        <Col md={6}>
                            <h6 className="fs-9 fw-normal">Il vous reste des questions ?</h6>
                            <Button variant="falcon-primary" size="sm" as={Link} to="/contact">
                                Contactez nous !
                            </Button>
                        </Col>
                        <Col md={6}>
                            <h6 className="fs-9 fw-normal">Beson d'un DPS ?</h6>
                            <Button variant="falcon-primary" size="sm" as={Link} to="/demandeDPS">
                                Je fais une demande de poste
                            </Button>
                        </Col>
                    </Row>
                    
                </div>
            </Card.Footer>
        </Card>
    </>);
};

export default DPSinfo;